/**
 * DynamicSectionCard.tsx — Renders a labelled section of resolved fields
 * inside a compact card.
 */

import React from 'react';
import type { DynamicEntitySectionData } from '@/modules/programs/types/dynamicEntityView';
import { DynamicFieldDisplay } from './DynamicFieldDisplay';

interface DynamicSectionCardProps {
  section: DynamicEntitySectionData;
  columns?: 1 | 2 | 3;
  className?: string;
}

export const DynamicSectionCard: React.FC<DynamicSectionCardProps> = ({
  section,
  columns = 2,
  className = '',
}) => {
  const sortedFields = [...section.fields]
    .filter((f) => f.visible)
    .sort((a, b) => a.order - b.order);

  if (sortedFields.length === 0) return null;

  const gridCols =
    columns === 3
      ? 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3'
      : columns === 2
        ? 'grid-cols-1 md:grid-cols-2'
        : 'grid-cols-1';

  return (
    <div className={`rounded-lg border bg-card p-4 ${className}`}>
      {section.title && (
        <h4 className="text-[14px] font-semibold text-foreground mb-3">
          {section.title}
        </h4>
      )}
      <dl className={`grid ${gridCols} gap-3`}>
        {sortedFields.map((field) => (
          <DynamicFieldDisplay key={field.fieldKey} field={field} />
        ))}
      </dl>
    </div>
  );
};
